﻿// @ts-ignore
import htmx from 'htmx.org';
htmx.config.globalViewTransitions = true;
// @ts-ignore
window.htmx = htmx;

